// import { Injectable } from '@angular/core';
import { Injectable } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Observable, combineLatest } from 'rxjs';
import { take } from 'rxjs/operators';
import { RequestReceiptComponent } from './request-receipt.component';
import { PurchaseService } from '@schoolbelle/api/purchase';
import { GroupService } from '@schoolbelle/api/group';

@Injectable({
  providedIn: 'root'
})
export class RequestReceiptModalService {

  constructor(
    private modal: BsModalService,
    private purchase: PurchaseService,
    private group:GroupService,
  ) { }


  open(
    defaults:{    
      CorpNum?:number,
      CorpName?:string,
      CEOName?:string,
      ContactName?:string,
      Addr?:string,
      Email?:string, 
      PayerName?:string,
    } = {}
  ):Observable<{
    purchase_ids:number[],
    CorpNum:number,				
    CorpName:string,			
    CEOName:string,				
    ContactName:string,		
    Addr:string, 
    Email:string,
    PayerName:string,
  }> {
    const modal:BsModalRef = this.modal.show(RequestReceiptComponent, {class:'modal-lg', initialState:{
      defaults,
    }}); 
    return modal.content.action.pipe(take(1))
  }
}
